import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export const dienstenItems = [
  { label: 'Product Sourcing China', href: '/diensten/product-sourcing', icon: 'ri-search-2-line', desc: 'Leverancier vinden & direct inkopen' },
  { label: 'Goedkoper Inkopen', href: '/diensten/prijsoptimalisatie', icon: 'ri-money-euro-circle-line', desc: '30–80% besparen op inkoopkosten' },
  { label: 'Private Label China', href: '/diensten/private-label', icon: 'ri-paint-brush-line', desc: 'Eigen merk & product uit China' },
  { label: 'Productiebegeleiding', href: '/diensten/productiebegeleiding', icon: 'ri-tools-line', desc: 'Kwaliteitscontrole & productie' },
  { label: 'DDP Import Levering', href: '/diensten/ddp-levering', icon: 'ri-truck-line', desc: 'All-in levering aan uw deur' },
  { label: 'Leveranciersbeheer', href: '/diensten/leveranciersbeheer', icon: 'ri-building-2-line', desc: 'Langetermijn leveranciersrelaties' },
];

export const dienstenLandingPages = [
  { label: 'Inkopen uit China', href: '/inkopen-uit-china', icon: 'ri-global-line' },
  { label: 'Goedkoop Inkopen China', href: '/goedkoop-inkopen-china', icon: 'ri-price-tag-3-line' },
  { label: 'Sourcing Service', href: '/sourcing-service', icon: 'ri-customer-service-2-line' },
  { label: 'Private Label China', href: '/private-label-china', icon: 'ri-vip-crown-line' },
];

export const blogItems = [
  { label: 'Geborduurde T-shirts', href: '/blog/geborduurde-tshirts-inkopen-china', icon: 'ri-t-shirt-2-line', price: '€6 → €35' },
  { label: 'Luxe wandlampen', href: '/blog/luxe-wandlampen-inkopen-china', icon: 'ri-lightbulb-line', price: '€40 → €250' },
  { label: 'EV laadkabels 22kW', href: '/blog/ev-laadkabels-inkopen-china', icon: 'ri-charging-pile-2-line', price: '€65 → €300' },
  { label: 'Bedrukte paper bags', href: '/blog/bedrukte-paper-bags-inkopen-china', icon: 'ri-shopping-bag-line', price: '100–300% markup' },
  { label: 'E-choppers', href: '/blog/e-choppers-inkopen-china', icon: 'ri-motorbike-line', price: '±€3.000 winst/stuk' },
  { label: 'Bedrukte tissues horeca', href: '/blog/bedrukte-tissues-horeca-inkopen-china', icon: 'ri-newspaper-line', price: 'Herhaalorders' },
];

export const voorWieItems = [
  { label: 'Horeca', href: '/voor-wie/horeca', icon: 'ri-store-2-line' },
  { label: 'Webshops', href: '/voor-wie/webshops', icon: 'ri-shopping-cart-line' },
  { label: 'Retail & Groothandel', href: '/voor-wie/retail', icon: 'ri-building-4-line' },
  { label: 'Gyms & Sportclubs', href: '/voor-wie/gyms', icon: 'ri-medal-line' },
  { label: 'Bedrijven & B2B', href: '/voor-wie/bedrijven', icon: 'ri-briefcase-4-line' },
  { label: 'Particulieren', href: '/voor-wie/particulieren', icon: 'ri-user-smile-line' },
  { label: 'Juweliers', href: '/voor-wie/juweliers', icon: 'ri-vip-diamond-line' },
  { label: 'Overig', href: '/voor-wie/overig', icon: 'ri-question-line' },
];

interface DropdownProps {
  onClose: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

interface BlogDropdownProps {
  onClose: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export function DienstenDropdown({ onClose, onMouseEnter, onMouseLeave }: DropdownProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 8, scale: 0.97 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-80 bg-white rounded-xl border border-[#0A1628]/10 py-2 z-[200]"
      style={{ boxShadow: '0 8px 30px rgba(10,22,40,0.10)' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <p className="px-4 pt-1 pb-1 text-[10px] uppercase tracking-widest text-[#0A1628]/35 font-600">Onze diensten</p>
      {dienstenItems.map((item) => (
        <Link
          key={item.label}
          to={item.href}
          onClick={onClose}
          className="w-full flex items-start gap-3 px-4 py-2.5 text-[#0A1628]/70 hover:text-[#3B9EE8] hover:bg-[#3B9EE8]/5 transition-all duration-150 group text-left cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#0A1628]/5 group-hover:bg-[#3B9EE8]/10 transition-colors flex-shrink-0 mt-0.5">
            <i className={`${item.icon} text-sm`} />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-500 leading-snug">{item.label}</div>
            <div className="text-xs text-[#0A1628]/40 group-hover:text-[#3B9EE8]/60 leading-snug">{item.desc}</div>
          </div>
        </Link>
      ))}
      <div className="mx-4 mt-1 pt-2 border-t border-[#0A1628]/8 flex flex-wrap gap-2">
        {dienstenLandingPages.map((lp) => (
          <Link key={lp.href} to={lp.href} onClick={onClose} className="inline-flex items-center gap-1.5 text-xs text-[#0A1628]/50 hover:text-[#3B9EE8] transition-colors py-1.5">
            <i className={`${lp.icon} text-xs`} />
            {lp.label}
          </Link>
        ))}
      </div>
    </motion.div>
  );
}

export function BlogDropdown({ onClose, onMouseEnter, onMouseLeave }: BlogDropdownProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 8, scale: 0.97 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-72 bg-white rounded-xl border border-[#0A1628]/10 py-2 z-[200]"
      style={{ boxShadow: '0 8px 30px rgba(10,22,40,0.10)' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <p className="px-4 pt-1 pb-1 text-[10px] uppercase tracking-widest text-[#0A1628]/35 font-600">Winning products</p>
      {blogItems.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          onClick={onClose}
          className="flex items-center gap-3 px-4 py-2 text-[#0A1628]/70 hover:text-[#3B9EE8] hover:bg-[#3B9EE8]/5 transition-all duration-150 group"
        >
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#0A1628]/5 group-hover:bg-[#3B9EE8]/10 transition-colors flex-shrink-0">
            <i className={`${item.icon} text-sm`} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-500 leading-snug truncate">{item.label}</div>
            <div className="text-xs text-[#3B9EE8]/70">{item.price}</div>
          </div>
        </Link>
      ))}
      <div className="mx-4 mt-1 pt-2 border-t border-[#0A1628]/8">
        <Link to="/blog" onClick={onClose} className="flex items-center justify-between py-2 text-[#3B9EE8] text-xs font-600 hover:text-[#2D85C5] transition-colors">
          <span>Bekijk alle winning products</span>
          <i className="ri-arrow-right-line text-xs" />
        </Link>
      </div>
    </motion.div>
  );
}

export function VoorWieDropdown({ onClose, onMouseEnter, onMouseLeave }: DropdownProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 8, scale: 0.97 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-72 bg-white rounded-xl border border-[#0A1628]/10 py-2 z-[200]"
      style={{ boxShadow: '0 8px 30px rgba(10,22,40,0.10)' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {voorWieItems.map((item) => (
        <Link
          key={item.label}
          to={item.href}
          onClick={onClose}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-[#0A1628]/70 hover:text-[#3B9EE8] hover:bg-[#3B9EE8]/5 transition-all duration-150 group text-left cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#0A1628]/5 group-hover:bg-[#3B9EE8]/10 transition-colors flex-shrink-0">
            <i className={`${item.icon} text-sm`} />
          </div>
          <span className="text-sm font-500">{item.label}</span>
        </Link>
      ))}
      <div className="mx-4 mt-1 pt-2 border-t border-[#0A1628]/8">
        <Link to="/voor-wie" onClick={onClose} className="flex items-center justify-between py-2 text-[#3B9EE8] text-xs font-600 hover:text-[#2D85C5] transition-colors">
          <span>Bekijk alle sectoren</span>
          <i className="ri-arrow-right-line text-xs" />
        </Link>
      </div>
    </motion.div>
  );
}
